import React from 'react';
import CloseIcon from '@tradera/blueprint/theme/icons2/close.svg?jsx';
import { Button } from 'tradera/components/atoms/button/button';
import styles from './header-with-close-button.module.scss';
import { classNames } from 'tradera/utils/class-names';

type ButtonProps = React.ComponentProps<typeof Button>;

type HeaderWithCloseButtonProps = {
    title?: string | React.ReactNode;
    border?: boolean;
    onClose?: ButtonProps['onClick'];
    menu?: React.ReactElement;
};

export const HeaderWithCloseButton = ({
    onClose,
    title,
    border,
    menu
}: HeaderWithCloseButtonProps) => {
    return (
        <div
            className={classNames(
                'd-flex align-items-center px-0 px-sm-1',
                styles.header,
                {
                    'border-bottom': !!border
                }
            )}>
            {menu || <div />}

            <h4 className="text-styled text-center mb-0 flex-grow-1 flex-shrink-1 py-1">
                {title}
            </h4>

            <Button
                data-test-header-close-button
                theme="text"
                size="md"
                round
                onClick={onClose}
                icon={<CloseIcon className="icon icon-sm" />}
            />
        </div>
    );
};
